import React, { useContext, useState, useEffect, useRef } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import TextInput from "./TextInput";
import { raiseGetRequest, raisePostRequest } from "../AxiosAPI";
import Select from 'react-select';
import { CrackersContext } from "../CrackersContext";


function AdminCrackersProp({}) {

    const {setShowErrorToastStatus, setToastBody} = useContext(CrackersContext);

    const [agentNo, setAgentNo] = useState('');
    const [crackersList, setCrackersList] = useState([]);
    const [selectedOption, setSelectedOption] = useState("");
    const [crackers, setCrackers] = useState('');
    const [crackersId, setCrackersId] = useState(-1);
    const [stockStaus, setStockStaus] = useState(1);
    const [status, setStatus] = useState(1);
    const [selectedHpCategory, setSelectedHpCategory] = useState([]);

    const validateAgent = async (agentNumber) => {
        var requestUri = `/admin/agents/${agentNumber}`;
        var response = await raiseGetRequest(requestUri, null, null, null);
        if(response.status && response.status === "failure") {
            alert(response.error_message);
        }

        requestUri = `/admin/agents/${agentNumber}/crackers`;
        response = await raiseGetRequest(requestUri, null, null, null);
        var crackersArray = [];
        for(let i=0; i<response.length; i++) {
            let crackers = response[i];
            crackersArray.push({value : crackers.id, label : crackers.name})
        }
        setCrackersList(crackersArray);
    }

    const getCrackers = async (selected) => {
        var requestUri = `/admin/agents/${agentNo}/crackers/${selected.value}`;
        const crackers = await raiseGetRequest(requestUri, null, setShowErrorToastStatus, setToastBody);
        setCrackers(crackers.crackersName);
        setCrackersId(selected.value);
        setSelectedOption(crackers.crackersName);
        setStatus(crackers.status);
        setStockStaus(crackers.stock_status)

        requestUri = `/admin/agents/${agentNo}/crackers/${selected.value}/hp-category`;
        var response = await raiseGetRequest(requestUri, null, setShowErrorToastStatus, setToastBody);
        setSelectedHpCategory(response);
    }

    const stockStatusChanges = async (value) => {
        var requestUri = `/admin/agents/${agentNo}/crackers/${crackersId}/stock-status`;
        var response = await raisePostRequest(requestUri, {"status" : value}, null, setShowErrorToastStatus, setToastBody);
        console.log(response);
    }

    const statusChanges = async (value) => {
        var requestUri = `/admin/agents/${agentNo}/crackers/${crackersId}/status`;
        var response = await raisePostRequest(requestUri, {"status" : value}, null, setShowErrorToastStatus, setToastBody);
    }

    const handleCategoryChange = (event) => {
        const selectedOptions = Array.from(event.target.selectedOptions, option => Number(option.value));
        if(selectedOptions.length != 0) {
            setSelectedHpCategory(selectedOptions);
        } else {
            setSelectedHpCategory([]);
        }
    };

    const updateHpCategory = async () => {
        var requestUri = `/admin/agents/${agentNo}/crackers/${crackersId}/hp-category`;
        var response = await raisePostRequest(requestUri, {"types" : JSON.stringify(selectedHpCategory)}, null, setShowErrorToastStatus, setToastBody);
    }

    return(
        <>
            <Row>
                <Col lg={1}></Col>
                <Col lg={2}>
                    <TextInput caption={"Agent Mob Number"}
                                value={agentNo}
                                onChange={setAgentNo}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Agent Mob Number"}
                                validator={validateAgent}
                                isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <div className="container mt-3" style={{ maxWidth: 400 }}>
                        <Select
                            options={crackersList}
                            value={selectedOption}
                            onChange={(selected) => getCrackers(selected)}
                            placeholder="Select Crackers..."
                            isSearchable
                        />
                    </div>
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={4}>
                    <TextInput caption={"Crackers Name"}
                                value={crackers}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Crackers Name"}
                                validator={null}
                                isMultiLine={false} />
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={1} className="d-flex align-items-center">
                    <Form.Label>Crackers status</Form.Label>
                </Col>
                <Col lg={4}>
                    <TextInput caption={"Crackers Status"}
                                value={status}
                                onChange={setStatus}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Crackers Status"}
                                validator={statusChanges}
                                isMultiLine={false} />
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={1} className="d-flex align-items-center">
                    <Form.Label>Stock status</Form.Label>
                </Col>
                <Col lg={4}>
                    <TextInput caption={"Stock Status"}
                                value={stockStaus}
                                onChange={setStockStaus}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Stock Status"}
                                validator={stockStatusChanges}
                                isMultiLine={false} />
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={1} className="d-flex align-items-center">
                    <Form.Label>Home Page Category</Form.Label>
                </Col>
                <Col lg={4}>
                    <Form.Select multiple value={selectedHpCategory} onChange={handleCategoryChange} style={{height : "120px"}}>
                        <option value="1">New Arrivals</option>
                        <option value="2">Trending Crackers</option>
                        <option value="3">Most Selling Crackers</option>
                        <option value="4">Best for Child</option>
                        <option value="5">Best for Adults</option>
                    </Form.Select>
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={4}></Col>
                <Col lg={1}></Col>
                <Col lg={1}>
                    <Button onClick={updateHpCategory}>Update</Button>
                </Col>
                <Col lg={2}></Col>
            </Row>

        </>
    );
}


export default AdminCrackersProp;